export const FIREBASE_SEND_SIGNIN_LINK_TO_EMAIL_KEY = 'firebase_send_signin_link_to_email_key'
export const ROOT_URL = '/'
export const LOGIN_PAGE_URL = '/login'
export const FINISH_SIGN_IN_PAGE_URL = '/finish-sign-in'
export const ORIGIN_QUERY_PARAM = 'origin'
